// Copyright (c) Ping. All rights reserved.

/**
 * User-facing copy for the pinned-messages screen. Centralised so the i18n
 * extraction step can hoist them into the localisation catalogues without
 * scanning component bodies.
 */
export const pinnedStrings = {
  screenTitle: 'Pinned messages',
  emptyTitle: 'No pinned messages yet',
  emptyBody: 'Pin a message to keep it handy at the top of the chat.',
  errorTitle: "Couldn't load pinned messages",
  errorRetry: 'Try again',
  unpinAction: 'Unpin',
  jumpToMessageAction: 'Jump to message',
  countSingular: '1 pinned',
  countPlural: (n: number): string => `${n} pinned`,
  countOverflow: '3+ pinned',
} as const;

export type PinnedStrings = typeof pinnedStrings;
